<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';

  import { SelectFilter } from '@client/components/filters/select';

  import { GroupsService } from '@client/services/groups';

  export let selected = '';
  export let onChange = () => {};

  let filter = null;
  let names = [];

  const syncSelection = (name) => {
    if (!filter) {
      return;
    }

    const current = names.includes(name) ? name : '';

    for (const key of Object.keys(filter)) {
      filter[key].enabled = key === current;
    }

    filter = filter;
  };

  onMount(async () => {
    const groups = await GroupsService.getAll();

    names = groups.map(({ groupname }) => groupname).sort((a, b) => a.localeCompare(b));

    filter = Object.fromEntries(names.map((name) => [name, { label: name, value: name, enabled: false }]));

    syncSelection(selected);
  });

  const onClick = (e, value) => onChange(value);
  const onClear = () => onChange('');

  $: syncSelection(selected);
</script>

{#if filter}
  <SelectFilter
    bind:filter
    param="group"
    search
    maxHeight="400px"
    placeholder={$format('label.SELECT_GROUP')}
    translateLabels={false}
    clearable
    {onClick}
    {onClear}
  />
{/if}
